import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import type { AppThunk } from '../store'
import { HTTP } from '../lib/axios'
import { LoadingPayload, MattersLoadingState } from '../types/common'
import { sortListByDate } from '../utils/common'
import { Matter } from '../types/matter'

export interface MattersState {
  loading: MattersLoadingState
  matters: Array<Matter>
}

export const initialState: MattersState = {
  loading: {
    matters: false
  },
  matters: []
}

const mattersSlice = createSlice({
  name: 'matters',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<LoadingPayload>) => {
      const clone = { ...state.loading, [payload.type]: payload.payload }
      state.loading = clone
    },
    setMatters: (state, { payload }: PayloadAction<Array<Matter>>) => {
      state.matters = sortListByDate(payload, 'dateCreated', true)
    }
  }
})

export const { setLoading, setMatters } = mattersSlice.actions
export default mattersSlice.reducer
export const mattersSelector = (state: { mattersStore: MattersState }) =>
  state.mattersStore

export const getMatters = (
  token: string,
  accountId: string,
  australisId: string
): AppThunk => {
  return async (dispatch) => {
    dispatch(setLoading({ type: 'matters', payload: true }))
    try {
      const res = await HTTP.get(
        `/matters/${accountId}/user/${australisId}/matter`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      if (res.data.url) {
        const s3Data = await axios.get(res.data.url)
        dispatch(setMatters(s3Data.data))
        dispatch(setLoading({ type: 'matters', payload: false }))
        return
      }
      dispatch(setMatters(res.data.matters))
      dispatch(setLoading({ type: 'matters', payload: false }))
    } catch (err) {
      console.log(err)
      dispatch(setLoading({ type: 'matters', payload: false }))
    }
  }
}
